<style scoped lang="scss" type="text/scss">
    .not-found-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #C2DEEF;
        display: flex;
        justify-content: center;
        align-items: center;

        .main-image {
            height: 60%;
        }
    }
</style>

<template>
    <div class="not-found-container">
        <img class="main-image" :src="backgroundImage" alt="">
    </div>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
                backgroundImage: 'https://robo-static.oss-cn-qingdao.aliyuncs.com/images/not-found.png'
            };
        }
    };
</script>
